module.exports = __webpack_public_path__ + "static/media/w30.919a8aff.svg";